<span class="icon {{name}} size-{{size}}" [ngClass]="{'is-html': htmlentity}" [ngStyle]="styles"
    title="{{title}}" aria-hidden="true" [innerHtml]="htmlentity | safeHtml">
</span>